import { useEffect } from 'react';
import toastr from 'toastr';
import fayeClient from '../services/fayeClient';

/**
 * Subscribes to the /error/{username} Faye channel to surface server-side
 * errors that are not covered by request-response patterns.
 *
 * @param {string} username - Current authenticated user's username
 */
function useFayeErrorHandler(username) {
  useEffect(() => {
    if (!username) return;

    const channel = '/error/' + username;

    const handleError = (message) => {
      if (message.type === 'NOT_LOGGED_IN') {
        console.warn('[FayeError] Session expired, redirecting to login');
        window.location.href = '/login';
        return;
      }

      const title = message.title || 'Error';
      const text = message.message || 'An unexpected error occurred.';
      toastr.error(text, title);
    };

    fayeClient.subscribe(channel, handleError);

    return () => {
      fayeClient.unsubscribe(channel, handleError);
    };
  }, [username]);
}

export default useFayeErrorHandler;
